import { Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@mui/material';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import { glb_sv, sendRequest, serviceList } from 'src/utils';

const ListActionDevice = ({ typeAction, dataDevice, permission }) => {
    const [getFlags, setGetFlags] = useState(false);
    const [tableData, setTableData] = useState([]);
    const { t } = useTranslation();
    const getRef = useRef(false);

    useEffect(() => {
        setTimeout(() => {
            getData();
        }, 1000);
    }, []);

    const getData = () => {
        if (getRef.current) {
            return;
        }
        getRef.current = true;
        const InVal = [
            moment().subtract(1, 'months').format('YYYYMMDD'),
            moment().format('YYYYMMDD'),
            dataDevice?.device_id ? dataDevice.device_id : 0,
        ];
        if (typeAction === 'borrow') {
            sendRequest(serviceList.getPepleTransaction, InVal, getDataResult, true, timeOutFunct, 40000);
        } else {
            sendRequest(serviceList.getPepleTransaction_ETK, InVal, getDataResult, true, timeOutFunct, 40000);
        }
    };

    const getDataResult = (reqInfoMap, message) => {
        getRef.current = false;
        setGetFlags(false);
        if ((message['proc_status']?.toString() || '0') === '0') {
            toast.error('Error: ' + message['proc_message']);
            return;
        } else {
            setTableData(message.proc_data.rows[0].o_1);
        }
    };

    const timeOutFunct = (reqInfo) => {
        getRef.current = false;
        setGetFlags(false);
    };

    if (tableData.length === 0) {
        return (
            <>
                <Stack className="srcoll-test" sx={{ maxHeight: '100%' }}>
                    {permission?.search_permission === '1' && (
                        <TableContainer>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell>{t('STT')}</TableCell>
                                        <TableCell align="left">{t('name_giver')}</TableCell>
                                        <TableCell align="left">{t('quantity_category')}</TableCell>
                                        <TableCell align="left">{t('day_borrow')}</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    <TableRow align="center" sx={{ color: 'red' }}>
                                        {t('emtyData')}
                                    </TableRow>
                                </TableBody>
                            </Table>
                        </TableContainer>
                    )}
                </Stack>
            </>
        );
    }

    return (
        <>
            <Stack className="srcoll-test" sx={{ maxHeight: '100%', overflowY: 'scroll' }}>
                {permission?.search_permission === '1' && (
                    <TableContainer>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t('STT')}</TableCell>
                                    <TableCell align="left">{t('name_giver')}</TableCell>
                                    <TableCell align="left">{t('quantity_category')}</TableCell>
                                    <TableCell align="left">{t('day_borrow')}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {tableData.length > 0 &&
                                    tableData.map((item, index) => (
                                        <TableRow key={index}>
                                            <TableCell>{index + 1}</TableCell>
                                            <TableCell align="left">{item?.user_nm}</TableCell>
                                            <TableCell align="left">{item?.qty}</TableCell>
                                            <TableCell align="left">
                                                {glb_sv.formatDate(item?.transaction_dt, 'YYYYMMDDHHmmss')}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                )}
            </Stack>
        </>
    );
};

export default ListActionDevice;
